import React, { useEffect } from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";

const relatedBlogs = [
    {
      contentType: "BLOG",
      title: "Complimenting Fleet Modernization with Road Safety",
      description: "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
      link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
      linkText: "Read article",
      thumbnail:
        "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    readTime: 10,
      },
    {
      contentType: "BLOG",
      title: "Envisioning the Future of Mobility with Shoora",
      description:
        "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
      thumbnail:
        "/images/thumbnails/14.jpeg",
      link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
    readTime: 10,
    },
  
    {
      contentType: "BLOG",
      title: "Tackling Distracted Driving: Transforming Fleet Safety",
      description:
        "By adopting the Three Ts—Talk, Train, and Track, Shoora addresses distracted driving head-on, protecting lives and optimising operations.",
      thumbnail: "/images/thumbnails/3.jpeg",
      link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
    readTime: 10,
    },
    {
      contentType: "BLOG",
      title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
      description:
        "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
      thumbnail:
        "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
      link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
    readTime: 10,
    },
    {
      contentType: "CUSTOMER STORY",
      title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
      description:
        "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
      thumbnail:
        "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
      link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
    readTime: 10,
    },
  
    {
      contentType: "CUSTOMER STORY",
      title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
      description:
        "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
      thumbnail: "/images/thumbnails/15.jpeg",
      link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
    readTime: 10,
    },
  ];
const data = {
    contentType: "BLOG",
    title:
        "How Shoora Aims to Leverage AIS-140’s Mandate for Telematics Devices in Public Transportation and Commercial Vehicles",
    description:
        "Moving into a new world of software-defined, service-driven digital mobility.",
    author: "Shoora",
    createdOn: "26th Oct, 2024",
    imgsrc:
        "https://www.easyembedded.net/images/ais2.jpg",
    readTime: 10,
    content: `  <p>
                The Government of India’s <strong>AIS-140</strong> standard, which
                mandates the installation of telematics devices in various types of
                public and commercial vehicles, represents a major leap forward in
                ensuring road safety, operational efficiency, and improved regulatory
                compliance. With a focus on <strong>
                    public transportation, taxis, cabs, National Permit Trucks, Oxygen
                    Carrying Tankers</strong>
                , and <strong>Hazardous Goods Vehicles</strong>, this regulation aims to
                enhance vehicle tracking, real-time monitoring, and data exchange, thus
                ensuring safety, security, and operational transparency.
            </p>

            <p>
                Shoora, a leader in <strong>advanced video telematics solutions</strong>
                , is committed to harnessing the potential of this mandate to create
                safer roads and smarter transportation systems. Here’s how Shoora plans
                to leverage AIS-140 to benefit these key sectors:
            </p>

            <h3>1. Ensuring Safety in Public Transportation Vehicles</h3>
            <p>
                Public transportation plays a vital role in keeping cities and
                communities connected. However, safety remains a significant concern.
                AIS-140 mandates the installation of telematics devices in public buses,
                helping authorities track vehicles, monitor driver behaviour, and ensure
                safety standards are met.
                <br /><br />
                Shoora’s <strong>AI-driven video telematics system</strong> will work
                alongside the AIS-140 devices to capture real-time video footage,
                enabling fleet operators to monitor driving habits and intervene in case
                of risky behaviours such as overspeeding, harsh braking, or distracted
                driving. Through real-time alerts, Shoora ensures that fleet managers
                can take immediate action, preventing accidents and improving passenger
                safety.
                <br /><br />
                Furthermore, the telematics system integrated with{" "}
                <strong>Shoora's fleet management software</strong> will offer insights
                into vehicle health, ensuring that critical safety features (brakes,
                lights, etc.) are well-maintained.
            </p>

            <h3>2. Improving Safety for Taxis and Cabs</h3>
            <p>
                With the rise of app-based taxi services, there is an urgent need for enhanced safety measures, especially for passengers and drivers. Shoora’s video telematics system can be integrated with AIS-140 devices to ensure that both the safety of the passengers and the security of the driver are prioritised.
                <br /><br />
                The inclusion of high-definition dash cams provides a dual benefit: <strong>recording in-cab interactions</strong> for passenger safety and capturing critical driving data to coach drivers on safe driving practices. The system’s <strong>real-time alerts</strong> notify drivers about unsafe driving actions like speeding, aggressive lane changes, or sudden stops, improving driver behaviour and reducing the likelihood of accidents. Moreover, Shoora’s <strong>integrated tracking system</strong> helps fleet operators ensure better operational efficiency and reduce response times to emergencies.
            </p>

            <h3>3. Streamlining Operations for National Permit Trucks</h3>
            <p>
                National Permit Trucks, which operate across state borders and cover long distances, require more than just a tracking device—they need a <strong>comprehensive fleet management solution</strong>. Shoora aims to enhance compliance with AIS-140 by providing a robust telematics system that integrates GPS, real-time location tracking, vehicle diagnostics, and <strong>driver behaviour monitoring</strong>.
                <br /><br />
                By enabling seamless tracking of National Permit Trucks, Shoora can help fleet operators monitor <strong>route adherence, fuel consumption, over-speeding</strong>, and <strong>rest breaks</strong>, ensuring compliance with road safety regulations and reducing the risk of driver fatigue and accidents. Additionally, with Shoora’s <strong>AI-powered video solutions</strong>, fleet managers can capture events like sudden braking or harsh turns, providing actionable insights to drivers for continuous improvement.
            </p>
            <h3>4. Monitoring Oxygen Carrying Tankers for Safety Compliance</h3>
            <p>
                Oxygen carrying tankers, especially with the recent focus on healthcare and the ongoing global health crisis, require high safety standards due to the volatile nature of the cargo. AIS-140 mandates telematics devices in such tankers to ensure their safe operation.
                <br /><br />
                Shoora plans to offer an added layer of safety by leveraging its video telematics system to monitor not only the tanker’s location and speed but also its driver’s actions. Real-time alerts about over-speeding, unsafe lane changes, or erratic driving can prevent accidents and ensure that the tanker reaches its destination without mishaps. Shoora’s live tracking capabilities also enable fleet managers to keep a constant watch on these critical vehicles, providing reassurance to both operators and recipients of the oxygen supply.
            </p>

            <h3>5. Enhancing Safety for Hazardous Goods Carrying Vehicles</h3>
            <p>
                Transporting hazardous materials comes with significant risks. Therefore, the installation of AIS-140-compliant telematics devices is crucial for monitoring the safety of vehicles carrying hazardous goods. Shoora’s telematics solutions are designed to complement this mandate by offering real-time data on vehicle movement, driver behaviour, and immediate alerts for any irregularities.
                <br /><br />
                Shoora’s AI-powered dash cams will capture driving events like harsh braking, speeding, or sudden acceleration, which can be especially dangerous when transporting hazardous materials. By alerting fleet managers immediately, Shoora helps them take quick corrective actions, preventing potential incidents or accidents that could result in severe consequences.
                <br /><br />
                Moreover, Shoora’s system will facilitate compliance with safety regulations, ensuring that hazardous goods vehicles adhere to prescribed routes, manage their fuel consumption, and follow safety protocols, all while being monitored through constant real-time data feeds.
            </p>

            <h3>
            6. Improving Regulatory Compliance
            </h3>
            <p>
                Shoora’s integration with AIS-140 not only supports the operational needs of fleet operators but also simplifies regulatory compliance. The data capture required by AIS-140 is enhanced with Shoora’s comprehensive fleet management system, which can track essential metrics such as driver activity, vehicle location, and maintenance status.
                <br /><br />
                By adhering to AIS-140 standards and leveraging Shoora’s real-time insights, fleet operators are better equipped to meet Government of India regulations, minimising the risk of non-compliance fines and penalties.
                <br /><br />
                
                
               
            </p>
            <blockquote>
‘Shoora is committed to supporting the Government of India’s vision of a safer, smarter, and more efficient transportation system. By integrating advanced telematics and video solutions into the AIS-140 framework, Shoora empowers fleet operators in public transportation, taxis, hazardous goods transport, and National Permit Trucks to enhance safety, improve operational efficiency, and ensure regulatory compliance.’
            </blockquote>
            <blockquote>
             ‘As telematics continue to shape the future of road safety, Shoora is proud to lead the charge in providing innovative, data-driven solutions that not only comply with government mandates but also drive meaningful improvements in road safety for everyone.’
            </blockquote>
`,
};
const LeverageAIS140 = () => {
    useEffect(()=> {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      },[]);
    return (
        <>
            <ArticleHero
                contentType={data?.contentType}
                title={data?.title}
                createdOn={data?.createdOn}
                imgsrc="/images/about/bg8.webp"
            />
            <div className="bg-dark">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a href="#">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a href="#">Insights</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a href="#" className="text-capitalize">
                                    {data?.contentType}s
                                </a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">
                                {data?.title}
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>



            <ArticleContainer data={data} />
            <hr className="border-3" style={{ borderColor: "var(--accent-color)" }} />
            <div
                className="stories-section section my-5"
                style={{ maxWidth: "100%" }}
            >
                <div className="container">
                    
                <FlipCardSlider data={relatedBlogs} title={"You may also like"}/>
                </div>
            </div>
        </>
    );
};

export default LeverageAIS140;
